<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1743752" style="color: #82a339"><b>APPLE AND PARSNIP SOUP</b></p>
<p class="ext" id="d7e1744252"><b><i>This creamy soup takes delicious advantage of autumn’s bounty. The puree is light, yet rich and flavorful with no need for cream.</i></b></p>
<p class="h4" id="d7e1745552" style="color: #496210"><b>Prep: 15 minutes Cook: 20 minutes</b></p>
<p class="ul" id="d7e1746052">1 package (32 ounces) chicken broth</p>
<p class="ul" id="d7e1746352">2 cups water</p>
<p class="ul" id="d7e1746952">1 tablespoon olive oil</p>
<p class="ul" id="d7e1747252">2 large shallots, finely chopped (½ cup)</p>
<p class="ul" id="d7e1748452">1 stalk celery, finely chopped</p>
<p class="ul" id="d7e1748752">2 pounds McIntosh or Braeburn apples (4 to 6 medium), <br/> peeled, cored, and chopped</p>
<p class="ul" id="d7e1749952">1 pound parsnips, peeled and chopped</p>
<p class="ul" id="d7e1750252">¼ teaspoon dried thyme</p>
<p class="ul" id="d7e1751252">½ teaspoon salt</p>
<p class="ul" id="d7e1752152">¼ teaspoon pepper <br/> roasted, hulled pumpkin seeds for garnish</p>
<p class="pub" id="d7e1753652" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In covered 2-quart saucepan, heat chicken broth and water to boiling over high heat.</p>
<p class="pub" id="d7e1754652"><span style="color: #c15b49"><b>2.</b></span> Meanwhile, in 5- to 6-quart saucepot, heat oil over medium heat. Add shallots and celery, and cook about 5 minutes or until softened and lightly browned. Add apples, parsnips, thyme, salt, and ground black pepper, and cook 1 minute.</p>
<p class="pub" id="d7e1757252"><span style="color: #c15b49"><b>3.</b></span> Add hot broth mixture to saucepot; cover and heat to boiling over high heat. Reduce heat to low and simmer, covered, 6 to 7 minutes or until parsnips are very tender.</p>
<p class="pub" id="d7e1759252"><span style="color: #c15b49"><b>4.</b></span> Spoon one-third of apple mixture into blender; cover, removing center part of lid to let steam escape. Lay a paper towel over top and puree until smooth. Pour puree into bowl. Repeat with remaining mixture. Return to saucepot to reheat. Garnish with pumpkin seeds to serve. Makes about 9 cups or 6 appetizer servings.</p>
<p class="ntx" id="d7e1762352">Each serving: About 160 calories, 3g protein, 34g carbohydrate, 3g total fat (0g saturated), 6g fiber, 0mg cholesterol, 600mg sodium.</p>
<p class="pub" id="d7e1765452"><span style="color: #c15b49"><b>Tip:</b></span> If you have an immersion blender, use it to puree soup right in the pot.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c46_r1.vue?392a6ac3